import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05c7f3a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-note" }
const _hoisted_2 = {
  key: 0,
  class: "beta"
}
const _hoisted_3 = {
  key: 1,
  class: "text-note__header"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-note__header-badge" }, null, -1))
const _hoisted_5 = { class: "text-note__body" }
const _hoisted_6 = {
  key: 2,
  class: "text-note__date"
}

interface Props {
  title?: string;
  date?: string;
  beta?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TextNote',
  props: {
    title: null,
    date: null,
    beta: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.beta)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "beta"))
      : _createCommentVNode("", true),
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, _toDisplayString(__props.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (__props.date)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.date), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})